<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>کاشت ابرو   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>کاشت ابرو به عملی گفته می شود که در آن گرافت ها یا فولیکول های مو از ناحیه موهای سر برداشته می شوند. سپس این گرافت ها در ناحیه ابرو کاشت داده شده تا در این محل رشد کنند. بنابراین موهای جدید ابرو از طریق گرافت های پیوند خورده رشد خواهند کرد. در این عمل از موهای طبیعی سر خود بیمار برای پیوند زدن استفاده می کنند.   </template>
                </m-h4><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/kashtabroobefore1.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/kashtabrooafter1.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/kashtabroobefore2.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/kashtabrooafter2.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/kashtabroobefore3.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/kashtabrooafter3.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-111.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-1.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-2788.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-25566.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-222.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-2.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-2556.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-2454.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-247.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/Untitled-2545456.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center mb-5" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
